import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import stravaLogo from '../../assets/images/strava.svg';
import femaleDefaultFoto from '../../assets/images/female_default.png';
import maleDefaultFoto from '../../assets/images/male_default.png';
import fireicon1 from '../../assets/images/fireicon1.svg';
import downIcon from '../../assets/images/down-chevron.svg';
import fireicon from '../../assets/images/fireicon.svg';
import upgreenrow from '../../assets/images/upgreenrow.svg';
import downredrow from '../../assets/images/downredrow.svg';

import { Row, Col } from 'react-flexbox-grid';

const TableRankingIndividualItem = ({
  userInfo,
  calendar,
  firstRaking,
  darkMode,
  individualFavorites,
  saveFavorite,
  deleteFavorite,
  selectedSegmentFilter,
  selectedTab,
  selectedCategory,
  segmentOrder,
  setSelectedUser,
}) => {
  const openStravaProfile = (stravaId) => {
    window.open(`https://www.strava.com/athletes/${stravaId}`, '_newtab');
  };

  const openAcordion = () => {
    setSelectedUser(userInfo);
  };

  const getCategory = () => {
    return userInfo.category === 'professional' ? 'Narinian' : userInfo.wave;
  };

  const getTabTimeName = () => {
    switch (selectedTab) {
      case 0:
        return 'k10';
      case 1:
        return 'k20';
      case 2:
        return 'k30';
      case 3:
        return 'k40';
      case 4:
        return 'k50';
      case 5:
        return 'k60';
      default:
        return 'elapsedTime';
    }
  };

  const fixNumber = (number) => {
    return Math.abs(number);
  };

  const addButtonText = () => {
    let buttonText = '+';
    let saveFunction = saveFavorite;
    let favoriteId = userInfo._id;
    if (individualFavorites) {
      individualFavorites.forEach((individualFavorite) => {
        if (individualFavorite.favorite === userInfo._id) {
          buttonText = '-';
          favoriteId = individualFavorite._id;
          saveFunction = deleteFavorite;
        }
      });
    }
    return (
      <div
        onClick={() => {
          saveFunction(favoriteId);
        }}
        className='add-button'
      >
        {buttonText}
      </div>
    );
  };

  const secondsToMinutesSeconds = (seconds) => {
    // Calculate the minutes by dividing the seconds by 60 and getting the integer part.
    const minutes = Math.floor(seconds / 60);
    // Calculate the remaining seconds by getting the modulo of the division by 60.
    const remainingSeconds = seconds % 60;

    // Format the output with leading zeros if necessary.
    const minutesWithZeros = minutes.toString().padStart(2, '0');
    const secondsWithZeros = remainingSeconds
      .toFixed(0)
      .toString()
      .padStart(2, '0');

    // Return the desired format.
    return `${minutesWithZeros}:${secondsWithZeros}`;
  };

  const showTime = (userInfo) => {
    const stageKey = getTabTimeName();
    const status = userInfo[[`${stageKey}_status`]];

    let currentLap = 'Vuelta 1/5';
    let totalTime = userInfo[`${stageKey}_1`];
    let pace = totalTime / 60 / 2;

    for (let i = 2; i <= 4; i++) {
      if (userInfo[`${stageKey}_${i}`] < 28800) {
        currentLap = `Vuelta ${i}/5`;
        totalTime += userInfo[`${stageKey}_${i}`];
        pace = totalTime / 60 / (i * 2);
      }
    }

    if (userInfo[stageKey] < 28800) {
      totalTime = userInfo[stageKey];
      pace = userInfo[stageKey] / 60 / 10;
    }

    const dnf = status === 3;
    const validTime = !dnf && status === 2;
    const waiting = status === 0;

    let accumulatedTime = 0;
    for (let i = 1; i <= stageKey.charAt(1); i++) {
      accumulatedTime += userInfo[`k${i * 10}`];
    }

    console.log('pace', pace);

    return (
      <div className={`${waiting ? 'waiting' : ''}`}>
        {dnf && 'DNF'}
        {waiting && 'Esperando tiempo'}
        {status === 1 && currentLap}
        {validTime && new Date(totalTime * 1000).toISOString().substr(11, 8)}
        {status === 1 && (
          <div className='note-text'>
            {new Date(totalTime * 1000).toISOString().substr(11, 8)}
          </div>
        )}
        {!dnf && !waiting && (
          <div className='note-text'>
            {secondsToMinutesSeconds(pace * 60)} min/km
          </div>
        )}
        {/* {validTime && stageKey !== 'k10' && (
          <div className='note-text bold'>
            {new Date(accumulatedTime * 1000).toISOString().substr(11, 8)}
          </div>
        )} */}
      </div>
    );
  };

  return (
    <Col xs={12} className={`table-ranking-item${darkMode ? ' darkMode' : ''}`}>
      <Row className='table-ranking-item_column-container'>
        <Col xs={12}>
          <Row className='table-ranking-item_column-container_main individual'>
            <Col
              xs={3}
              md={2}
              className='table-ranking-item_column position-ranking-column'
            >
              {addButtonText()}
              <div className='raking-buton'>
                <div className='position-text'>{userInfo.rank + 1}</div>
              </div>
            </Col>
            <Col
              xs={6}
              md={8}
              className='table-ranking-item_column'
              onClick={() => {
                if (userInfo.stravaId) {
                  openStravaProfile(userInfo.stravaId);
                }
              }}
            >
              <div className='table-ranking-item_user-img-container'>
                <img
                  src={
                    userInfo.photoUrl ||
                    (userInfo.gender === 'female' ? fireicon1 : fireicon1)
                  }
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      userInfo.gender === 'female' ? fireicon1 : fireicon1;
                  }}
                  alt='user'
                  className={`table-ranking-item_user-img ${userInfo.gender}`}
                />
                {userInfo.stravaId && (
                  <img
                    src={stravaLogo}
                    alt='strava logo'
                    className='strava-logo individual'
                  />
                )}
              </div>
              <div className='table-ranking-item_user-info-container'>
                <div className='table-ranking-item_user-info-name'>
                  {`${userInfo.name} ${userInfo.lastName}`}
                </div>
                <div className='table-ranking-item_user-info-team'>
                  <span className='wave-container'>{getCategory()}</span>
                </div>
              </div>
              {userInfo.category === 'professional' && (
                <div className='table-ranking-item_user-img-container specialized'>
                  <img src={fireicon} alt='user' className='specialized-icon' />
                </div>
              )}
              <div className='table-ranking-item_user-img-container specialized'>
                {userInfo.shoesBrand === 'Nike' && (
                  <img
                    src={fireicon1}
                    alt='user'
                    className='specialized-icon'
                  />
                )}
              </div>
            </Col>
            <Col xs={3} md={2} className='table-ranking-item_column'>
              <div className='table-ranking-item_category'>
                {showTime(userInfo)}
              </div>
            </Col>
            {/* <Col
              xs={3}
              className='table-ranking-item_column cursor'
              onClick={openAcordion}
            >
              <div className='table-ranking-item_category'>
                {showTime(
                  userInfo[
                    selectedSegmentFilter
                      ? selectedSegmentFilter
                      : getTabTimeNamePartial()
                  ],
                  userInfo.status,
                  userInfo.note
                )}
                <img src={downIcon} alt='down' className='down-icon' />
              </div>
            </Col> */}
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

TableRankingIndividualItem.propTypes = {
  saveFavorite: PropTypes.func.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  deleteFavorite: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  firstRaking: PropTypes.object.isRequired,
  calendar: PropTypes.bool,
  darkMode: PropTypes.bool,
  segmentOrder: PropTypes.bool,
  individualFavorites: PropTypes.array.isRequired,
  selectedSegmentFilter: PropTypes.string,
  selectedTab: PropTypes.number,
  selectedCategory: PropTypes.string,
};

TableRankingIndividualItem.defaultProps = {
  calendar: false,
  darkMode: false,
  segmentOrder: false,
  selectedSegmentFilter: null,
  selectedCategory: '',
};

export default TableRankingIndividualItem;
